import * as z from 'zod';
import {
  requiredEmail,
  requiredPhoneSchema,
  requiredText,
} from '@/modules/service-requests/shared/application-utils';

/** Every BYOD field is mandatory in the legacy form. */
export const byodApplySchema = z.object({
  firstName: requiredText('FIRST_NAME_REQUIRED', 100),
  lastName: requiredText('LAST_NAME_REQUIRED', 100),
  email: requiredEmail('EMAIL_REQUIRED'),
  phoneNumber: requiredPhoneSchema('PHONE_NUMBER_REQUIRED'),
  employeeId: requiredText('EMPLOYEE_ID_REQUIRED', 50),
  designation: requiredText('DESIGNATION_REQUIRED', 150),
  bankAccount: requiredText('BANK_ACCOUNT_REQUIRED', 40),
  departmentId: z.string().trim().min(1, { message: 'DEPARTMENT_REQUIRED' }),
  deviceModel: requiredText('DEVICE_MODEL_REQUIRED', 200),
  computerProcessor: requiredText('COMPUTER_PROCESSOR_REQUIRED', 200),
  motherboard: requiredText('MOTHERBOARD_REQUIRED', 200),
  ramCapacity: requiredText('RAM_CAPACITY_REQUIRED', 200),
  monitorSpec: requiredText('MONITOR_SPEC_REQUIRED', 200),
  storageSpec: requiredText('STORAGE_SPEC_REQUIRED', 200),
});

export type ByodApplyValues = z.infer<typeof byodApplySchema>;
